import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root'
})
export class ProgramCatalogueService {

    EcpUrl = environment.apiUrl;

    constructor(private http: HttpClient){}

    public getMyHeirarchy(userID:string){
        return this.http.get(`${this.EcpUrl}User/GetManagerHierarchy?managerId=${+userID}`);
    }
    public getAllPrograms(filters: any) {
        return this.http.get(`${this.EcpUrl}Program/FetchProgramsToAssign?practiceId=${filters.practiceID}&departmentId=${filters.departmentID}&gradeId=${filters.gradeID}`);
    }
    public getProgramDetails(){
        return this.http.get(`${this.EcpUrl}Program/GetAllDropdownValues`);
    }
    public assignPrograms(assignPrograms: any) {
        return this.http.post(`${this.EcpUrl}Program/AssignPrograms`, assignPrograms);
    }
    public getAllProgramsInExport(programIds: number[] = [0]) {
        return this.http.post(`${this.EcpUrl}Program/GetAllPrograms`, programIds);
    }
}
